<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-2">
          <router-link
            :to="{ path: '/ConfigurableProducts/Create' }"
            class="vs-component vs-button bg_l_green"
            v-has-permission="permission141"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />{{
              $t("CreateNewConfigurableProduct")
            }}
          </router-link>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Title') },
              { title: $t('PersianTitle') },
              { title: $t('ItemCode') },
              { title: $t('ModelNumber') },
              { title: $t('GenericProductName') },
              { title: $t('Action') }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width:20%">
                {{ row.name }}
              </td>
              <td style="width:17%;">
                {{ row.persianName }}
              </td>
              <td style="width:14%;">
                {{ row.itemCode }}
              </td>
              <td style="width:14%;">
                {{ row.modelNumber }}
              </td>
              <td style="width:17%;">
                {{ row.genericProductName }}
              </td>
              <td style="width:15%">
                <router-link
                  :to="{ path: '/ConfigurableProducts/edit/' + row.id }"
                >
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="ml-4 d-inline"
                  ></vs-button>
                </router-link>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deleteConfigurableProduct(row.id)"
                  class="d-inline"
                  v-has-permission="permission142"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  components: {
    DataGrid
  },
  data() {
    return {
      permission141: "CreateConfigurableProduct",
      permission142: "DeleteConfigurableProduct",
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/ConfigurableProductsQuery"
      },
      gridSearchData: {}
    };
  },
  methods: {
    ...mapActions({
      removeConfigurableProduct: "configurableProducts/remove"
    }),
    //Delete Method
    deleteConfigurableProduct(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removeConfigurableProduct(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    }
  }
};
</script>
